module.exports = function (btsUi) {
    require('./healthToolsService')(btsUi);
    var healthToolModal= require("./modals/healthToolModal");
    btsUi.directive('healthTool', function () {
        var templateUrl = '/content/minnesota/en/minnesotacore/shared/footer.appTemplate.html/directives/healthTools/healthTool';

        return {
            templateUrl: templateUrl,
            scope: {
                toolContent: "@",
                aemEditMode: "@",
                toolMultiLinkFields: "@",
                toolVendorLinks:"@",
                toolVendorLinks2:"@",
                toolDisclaimerDetails:"@"
            },


            controller: ['$scope', 'coremetrics', 'modal', 'vendorSSOUtility', 'healthToolsService', '$window', 'session', 'ssoServiceHelper', '$rootScope', '$timeout', 'pharmacyServiceWrapper', 'services',
                function ($scope, coremetrics, modal, vendorSSOUtility, healthToolsService, $window, session, ssoServiceHelper, $rootScope, $timeout, pharmacyServiceWrapper, services) {

                    $scope.showTool = false;



                    //data from AEM component dialog
                    var aemContent = $scope.toolContent ? JSON.parse($scope.toolContent) : "";
                    var toolMultiLinkFields = $scope.toolMultiLinkFields && $scope.toolMultiLinkFields.length>0? JSON.parse($scope.toolMultiLinkFields) : "";
                    var toolVendorLinks = $scope.toolVendorLinks && $scope.toolVendorLinks.length>0? JSON.parse($scope.toolVendorLinks) : "";
                    var toolVendorLinks2 = $scope.toolVendorLinks2 && $scope.toolVendorLinks2.length>0? JSON.parse($scope.toolVendorLinks2) : "";
                    var toolDisclaimerDetails = $scope.toolDisclaimerDetails && $scope.toolDisclaimerDetails.length>0? JSON.parse($scope.toolDisclaimerDetails) : "";


                    $scope.isAEMEditMode = aemContent && aemContent.iswcmEditMode && aemContent.iswcmEditMode=="true"? true : false;
                    $scope.disableSSO = aemContent?aemContent.disableSSO:"";

                    var suppressGroups = (aemContent && aemContent.suppressGroups && aemContent.suppressGroups.length > 0) ? aemContent.suppressGroups : "";
                    var suppressClients = (aemContent && aemContent.suppressClients && aemContent.suppressClients.length > 0) ? aemContent.suppressClients : "";
                    var eligibleGroups = (aemContent && aemContent.eligibleGroups && aemContent.eligibleGroups.length > 0) ? aemContent.eligibleGroups : "";
                    var eligibleClients = (aemContent && aemContent.eligibleClients && aemContent.eligibleClients.length > 0) ? aemContent.eligibleClients : "";

                    var memberLoggedIn = (session && session.data && session.data.loggedIn) ? session.data.loggedIn : false;
                    $scope.toolType = (aemContent && aemContent.toolType) ? aemContent.toolType.trim().toUpperCase() : "";

                    $scope.openURL = false;
                    $scope.linkClicked = false;
                    $scope.popUplinkClicked = false;
                    $scope.coremetricsCategoryTag = (aemContent && aemContent.cmCategoryTag) ? aemContent.cmCategoryTag.trim().toUpperCase() : "MEMBER:MEMBER HOME";

                    if($scope.toolType && memberLoggedIn){
                        var supressTool = healthToolsService.initialCheck(suppressGroups, suppressClients,eligibleGroups,eligibleClients);
                        if (!supressTool) {
                            getToolDetails();
                        }
                    }else if ($scope.toolType &&  $scope.toolType === 'GENERIC-TOOL') {
                        getToolDetails();
                    }

                    function getAEMPrescriptionVendorLinks(){
                        var vendorURLData ={arrPharmacyProviderUrls:{},arrPharmacyProviders:{},drugCoverageProviderUrls:{},drugCoverageProviders:{},drugCoverageUrls:{}};

                        if(aemContent &&  aemContent.vendorNames && aemContent.vendorNames.length>0){
                            vendorURLData.arrPharmacyProviders=aemContent.vendorNames;
                        }
                        if(aemContent &&  aemContent.vendorNames2 && aemContent.vendorNames2.length>0){
                            vendorURLData.drugCoverageProviders=aemContent.vendorNames2;
                        }


                        if(toolVendorLinks && toolVendorLinks.length>0){
                            for (var i = 0; i < toolVendorLinks.length; i++) {
                                var itemContent = toolVendorLinks[i].props;
                                //get url data
                                var urlDetails ={};
                                urlDetails.url=itemContent.multiLinkUrl?itemContent.multiLinkUrl:"";
                                urlDetails.isSSO= (itemContent.enableSSO && itemContent.enableSSO=='true')?"YES":"NO";
                                urlDetails.target = (itemContent.multiNewWindow && itemContent.multiNewWindow=="true")?"_blank":"_self";
                                var vendorName = itemContent.vendorName ?itemContent.vendorName.trim().toUpperCase():"DEFAULT";
                                urlDetails.sitePromotionTag = itemContent.sitePromotionTag ?encodeURI(itemContent.sitePromotionTag.trim()):"";
                                vendorURLData.arrPharmacyProviderUrls[vendorName]=urlDetails;

                            }
                        }
                        if(toolVendorLinks2 && toolVendorLinks2.length>0){
                            for (var i = 0; i < toolVendorLinks2.length; i++) {
                                var itemContent = toolVendorLinks2[i].props;
                                //get url data
                                var urlDetails ={};
                                urlDetails.url=itemContent.multiLinkUrl?itemContent.multiLinkUrl:"";
                                urlDetails.isSSO= (itemContent.enableSSO && itemContent.enableSSO=='true')?"YES":"NO";
                                urlDetails.target = (itemContent.multiNewWindow && itemContent.multiNewWindow=="true")?"_blank":"_self";
                                var vendorName = itemContent.vendorName?itemContent.vendorName.trim().toUpperCase():"DEFAULT";
                                urlDetails.sitePromotionTag = itemContent.sitePromotionTag ?encodeURI(itemContent.sitePromotionTag.trim()):"";
                                vendorURLData.drugCoverageProviderUrls[vendorName]=urlDetails;

                            }
                        }
                        return vendorURLData;
                    }
                    var toolCoremetricsTagging=function(toolType){
                        if (!$scope.linkClicked) {
                            switch(toolType){
                                case 'PAY-PREMIUM':
                                    coremetrics.createManualLinkClickTag($scope.toolLinkUrl,null,null);
                                    break;
                                case 'FIND-DOCTOR':
                                    coremetrics.createManualLinkClickTag($scope.toolLinkUrl, null, null);
                                    break;
                                case 'TELE-MEDICINE':
                                    var coremetricsTags =  ($scope.ssoContent && $scope.ssoContent.coremetrics)?$scope.ssoContent.coremetrics:"";
                                    var coremetricsElementTag = coremetricsTags && coremetricsTags.elementTag ? coremetricsTags.elementTag : "";
                                    var coremetricsPageViewTag = coremetricsTags && coremetricsTags.mbrPageviewTag ? coremetricsTags.mbrPageviewTag : "";
                                    coremetrics.elementTag(coremetricsElementTag, $scope.coremetricsCategoryTag);
                                    coremetrics.pageviewTag(coremetricsPageViewTag, $scope.coremetricsCategoryTag);
                                    break;
                                case 'PRESCRIPTION-SERVICE':
                                    coremetrics.createManualLinkClickTag($scope.toolLinkUrl, null, null);
                                    break;
                                case 'COST-ESTIMATOR':
                                    if($scope.isCCE){
                                        coremetrics.elementTag('Estimates Costs for Care',$scope.coremetricsCategoryTag);
                                    } if($scope.isCHC){
                                        coremetrics.elementTag('Savings Advisor Link',$scope.coremetricsCategoryTag);
                                    }
                                    break;
                                case 'MEMBER-FORMS':
                                    coremetrics.createManualLinkClickTag($scope.toolLinkUrl, null, null);
                                    break;
                                case 'RETAIL-CENTER':
                                    coremetrics.createManualLinkClickTag($scope.toolLinkUrl, null, null);
                                    break;
                                case 'ID-PROTECTION':
                                    coremetrics.createManualLinkClickTag($scope.toolLinkUrl, null, null);
                                    break;
                                case 'GENERIC-TOOL':
                                    coremetrics.createManualLinkClickTag($scope.toolLinkUrl, null, null);
                                    break;
                                default:
                                    coremetrics.createManualLinkClickTag($scope.toolLinkUrl, null, null);
                            }
                            $scope.linkClicked = true;
                        }

                    }


                    function getToolDetails() {
                        var cmSP="";
                        var toolType = $scope.toolType || '';
                        $scope.target = aemContent.toolTarget;
                        $scope.toolTitle = aemContent.toolLabel;
                        $scope.toolExternalIcon = aemContent.linkImage;
                        $scope.toolImageIcon = aemContent.toolImageIcon;
                        $scope.toolImageAlt = aemContent.toolImageAlt;
                        if(aemContent && aemContent.linkSitePromotionTag){
                            cmSP = "?cm_sp="+aemContent.linkSitePromotionTag;
                            cmSP =  encodeURI(cmSP);
                        }
                        $scope.toolLinkUrl = aemContent.toolLinkUrl?aemContent.toolLinkUrl+cmSP:"";

                        if (toolType === 'GENERIC-TOOL' || toolType === 'FIND-DOCTOR' || toolType === 'MEMBER-FORMS'
                            || toolType === 'RETAIL-CENTER' || toolType === 'ID-PROTECTION') {
                            $scope.showTool = true;
                            $scope.openURL = true;
                        } else if (toolType === 'COST-ESTIMATOR') {
                            getCostEstimatesData();
                        } else if ($scope.toolType === 'SIMPLICITY-RX') {
                            getCurGrpData();
                        } else if (toolType === 'TELE-MEDICINE') {
                            getTeleMedicineData();
                        } else if (toolType === 'PAY-PREMIUM') {
                            getPayPremiumData();
                        } else if (toolType === 'PRESCRIPTION-SERVICE') {
                            getPrescriptionServiceData();
                        }else if (toolType === 'GUIDE-WELL') {
                            getGuideWellData();
                        }
                    }
                    function getCurGrpData(){
                        var medRxProduct = healthToolsService.curMedicareGrpProd();

                        if(medRxProduct){
                            for (var i = 0; i < medRxProduct.length; i++) {
                                if (medRxProduct[i].benefitPlanNumber !== '' &&  medRxProduct[i].contractNumberCms !== '') {
                                    $scope.showTool = true;
                                    $scope.urlParamsSRX = "contract="+ medRxProduct[i].contractNumberCms+"&pbp="+medRxProduct[i].benefitPlanNumber;
                                    return;
                                }
                            }
                           //not checking for active products because we want to be able to see the tool during OEP period for future coverage as well.


                        }

                    }
                    function getGuideWellData(){
                        var showGuideWell=healthToolsService.showGuideWell();
                        if(showGuideWell){
                            $scope.showTool = true;
                            $scope.openURL = true;
                        }

                    }

                    function getCostEstimatesData() {
                        var cceData = healthToolsService.getCCEData();
                        $scope.isCHC = false;
                        $scope.isCCE = false;
                        var cmSP="";
                        if (cceData.showCCELink) {
                            $scope.isCCE=true;
                            $scope.showTool = true;
                            var showCastLight=false;
                            var clientsList = aemContent.clientsList;
                            if (clientsList && clientsList.length > 0) {
                                var clientNumber =  healthToolsService.getModel().selectedClient.clientNumber;
                                if (clientNumber && clientsList.indexOf(clientNumber) > -1) {
                                    showCastLight=true;
                                }
                            }
                            if(showCastLight){
                                $scope.target = aemContent.toolTarget2 ? aemContent.toolTarget2 : aemContent.toolTarget;
                                $scope.toolTitle = aemContent.toolLabel2 ? aemContent.toolLabel2 : aemContent.toolLabel;
                                $scope.toolImageIcon = aemContent.iconReference2?aemContent.iconReference2:aemContent.toolImageIcon;
                                $scope.toolImageAlt = aemContent.alt2?aemContent.alt2:aemContent.toolImageAlt;

                                if(aemContent && aemContent.linkSitePromotionTag2){
                                    cmSP = "?cm_sp="+aemContent.linkSitePromotionTag2;
                                    cmSP =  encodeURI(cmSP);
                                }
                                $scope.toolLinkUrl = aemContent.toolLinkUrl2?aemContent.toolLinkUrl2+cmSP:"";
                            }
                            else{
                                if ($scope.toolLinkUrl && $scope.toolLinkUrl.indexOf('groupNumber') > -1) {
                                    $scope.toolLinkUrl = $scope.toolLinkUrl.split('groupNumber').join(cceData.groupNumber);
                                }
                                if ($scope.toolLinkUrl && $scope.toolLinkUrl.indexOf('effectiveDate') > -1) {
                                    $scope.toolLinkUrl = $scope.toolLinkUrl.split('effectiveDate').join(cceData.effDate);
                                }
                            }

                        }
                        if(healthToolsService.showCHC()){
                            $scope.showTool=true;
                            $scope.isCHC=true;
                            $scope.target = aemContent.toolTarget3 ? aemContent.toolTarget3 : aemContent.toolTarget;
                            $scope.toolTitle = aemContent.toolLabel3 ? aemContent.toolLabel3 : aemContent.toolLabel;
                            $scope.toolImageIcon = aemContent.iconReference3?aemContent.iconReference3:aemContent.toolImageIcon;
                            $scope.toolImageAlt = aemContent.alt3?aemContent.alt3:aemContent.toolImageAlt;

                            if(aemContent && aemContent.linkSitePromotionTag3){
                                cmSP = "?cm_sp="+aemContent.linkSitePromotionTag3;
                                cmSP =  encodeURI(cmSP);
                            }
                            $scope.toolLinkUrl = aemContent.toolLinkUrl3?aemContent.toolLinkUrl3+cmSP:"";
                            //set SSO variables
                            var ssoParams = {};
                            ssoParams.targetType = aemContent && aemContent.ssoTargetType?aemContent.ssoTargetType:"";
                            ssoParams.category = aemContent && aemContent.ssoCategory?aemContent.ssoCategory:"";
                            ssoParams.vendorName = aemContent && aemContent.ssoVendorName?aemContent.ssoVendorName:"";
                            ssoParams.returnPage = aemContent && aemContent.ssoReturnPage?aemContent.ssoReturnPage:"";
                            ssoParams.returnUrl = aemContent && aemContent.ssoReturnUrl?aemContent.ssoReturnUrl:"";
                            ssoParams.sitePromotionStr=aemContent && aemContent.ssoSitePromotionTag?encodeURI(aemContent.ssoSitePromotionTag):"";
                            ssoParams.disableSSO = aemContent && aemContent.disableSSOCall?aemContent.disableSSOCall:"no";
                            $scope.chcSSOParams = ssoParams;
                        }
                    }

                    function getAEMDisclaimerData(){
                        var disclaimerData={};
                        if(toolDisclaimerDetails && toolDisclaimerDetails.length > 0){
                            for (var i = 0; i < toolDisclaimerDetails.length; i++) {
                                var itemContent = toolDisclaimerDetails[i].props;
                                var content={};
                                var vendorName = itemContent.vendorName?itemContent.vendorName.trim().toUpperCase():"ONLINECAREANYWHERE";
                                content.modelContent = itemContent.modelContent ? itemContent.modelContent.replace(/\n\r/g, '') : "";
                                content.modelTitle = itemContent.modelTitle ? itemContent.modelTitle: "";
                                content.cmElementTag = itemContent.cmElementTag ? itemContent.cmElementTag: "";
                                content.cmPageviewTag = itemContent.cmPageviewTag ? itemContent.cmPageviewTag: "";
                                content.cmFinderPageviewTag = itemContent.cmFinderPageviewTag ? itemContent.cmFinderPageviewTag: "";
                                disclaimerData[vendorName]=content;
                            }
                        }
                        return disclaimerData;
                    }
                    function getAEMTeleMedicineSSOData(){
                        var vendorURLData={};
                        var ssoData = [];
                        var urlData = [];
                        if(toolMultiLinkFields && toolMultiLinkFields.length > 0){
                            for (var i = 0; i < toolMultiLinkFields.length; i++) {
                                var itemContent = toolMultiLinkFields[i].props;
                                var teleVendorName = itemContent.teleVendorName?itemContent.teleVendorName.trim().toUpperCase():"ONLINECAREANYWHERE";
                                //get url data
                                var urlDetails ={coremetrics:{}};

                                urlDetails.label=itemContent.multiToolLabel?itemContent.multiToolLabel:"";
                                urlDetails.href=itemContent.multiLinkUrl?itemContent.multiLinkUrl:"";
                                urlDetails.coremetrics.sitePromotionTag=itemContent.urlSitePromotion?encodeURI(itemContent.urlSitePromotion):"";
                                urlDetails.target = (itemContent.multiNewWindow && itemContent.multiNewWindow=="true")?"_blank":"_self";
                                urlData.push(urlDetails);
                                //get sso data
                                var ssoDetails ={};
                                ssoDetails.targetType=itemContent.targetType?itemContent.targetType:"";
                                ssoDetails.category=itemContent.category?itemContent.category:"";
                                ssoDetails.vendorName=itemContent.vendorName?itemContent.vendorName:"";
                                ssoDetails.targetLocation = (itemContent.multiNewWindow && itemContent.multiNewWindow=="true")?"_blank":"_self";
                                ssoDetails.sitePromotionStr=itemContent.ssoSitePromotion?encodeURI(itemContent.ssoSitePromotion):"";
                                ssoDetails.disableSSO=(itemContent.disableSSO && itemContent.disableSSO=='true')?"yes":"no";

                                ssoData.push(ssoDetails);

                                if(!vendorURLData[teleVendorName]){
                                    vendorURLData[teleVendorName]={};
                                }
                                if(vendorURLData[teleVendorName]){

                                    if( !vendorURLData[teleVendorName].urlData) {
                                        vendorURLData[teleVendorName].urlData=[];
                                    }
                                    vendorURLData[teleVendorName].urlData.push(urlDetails);
                                    if(!vendorURLData[teleVendorName].ssoData) {
                                        vendorURLData[teleVendorName].ssoData=[];
                                    }
                                    vendorURLData[teleVendorName].ssoData.push(ssoDetails);

                                }
                            }
                        }
                        return vendorURLData;
                    }

                    function getTeleMedicineData() {
                        var teleVendorName = healthToolsService.getTelemedicineVendorName();
                        teleVendorName = teleVendorName?teleVendorName.trim().toUpperCase():"";
                        var teleMedicineSSOData = getAEMTeleMedicineSSOData();
                        if (teleVendorName && teleMedicineSSOData[teleVendorName]) {

                            var disclaimerData = getAEMDisclaimerData();
                            var disclaimerContent = disclaimerData && disclaimerData[teleVendorName]? disclaimerData[teleVendorName] : "";

                            var urlData =teleMedicineSSOData[teleVendorName].urlData;
                            var ssoData =teleMedicineSSOData[teleVendorName].ssoData;


                            if (urlData.length>0) {
                                $scope.showTool = true;
                                $scope.ssoContent = {};
                                $scope.ssoContent.url = urlData;//vendorJsonData.url;
                                $scope.ssoContent.sso = ssoData;//vendorJsonData.sso;
                                var coremetrics = {};
                                coremetrics.finderPageviewTag= disclaimerContent?disclaimerContent.cmFinderPageviewTag:"";
                                coremetrics.elementTag= disclaimerContent?disclaimerContent.cmElementTag:"";
                                coremetrics.mbrPageviewTag= disclaimerContent?disclaimerContent.cmPageviewTag:"";
                                $scope.ssoContent.coremetrics = coremetrics;
                                $scope.ssoContent.disclaimer = disclaimerContent.modelContent ? disclaimerContent.modelContent: "";
                                $scope.ssoContent.title = disclaimerContent.modelTitle ? disclaimerContent.modelTitle : "";
                            }


                        }

                    }

                    function getPayPremiumData() {
                        var payPremiumData = healthToolsService.getPayPlanPremium();
                        var cmSP="";
                        if (payPremiumData.showPayPlanPremium) {
                            $scope.showTool = true;
                            healthToolsService.checkIfEbillUserExists().then(function(response){
                                var payPlanPremiumAccountExists = (response && response.data && response.data.payload
                                && response.data.payload.ebillAccountexists && response.data.payload.ebillAccountexists != 'N');
                                if (payPlanPremiumAccountExists) {

                                    $scope.target = aemContent.toolTarget2 ? aemContent.toolTarget2 : aemContent.toolTarget;
                                    $scope.toolTitle = aemContent.toolLabel2 ? aemContent.toolLabel2 : aemContent.toolLabel;
                                    if(aemContent && aemContent.linkSitePromotionTag2){
                                        cmSP = "?cm_sp="+aemContent.linkSitePromotionTag2;
                                        cmSP =  encodeURI(cmSP);
                                    }
                                    $scope.toolLinkUrl = aemContent.toolLinkUrl2?aemContent.toolLinkUrl2+cmSP:"";
                                }
                            },function(error){
                                console.log("Service call failed while verifying if ebillAccount exists for a member");
                            });
                        }
                        $scope.openURL = true;

                    }

                    function getSavingsAdvisorData() {
                        $scope.showTool = healthToolsService.showCHC();

                    }

                    function getPrescriptionServiceData() {
                        var showPrescription = false;
                        var prescriptionServicesJson = getAEMPrescriptionVendorLinks();
                        var prescriptionServices = healthToolsService.showPrescriptionServices(prescriptionServicesJson);
                        var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan();
                        var milliServerDate = Date.parse(new Date());
                        for(var i = 0; i < portalSelectedPlan.productList.length; i++) {
                            if(portalSelectedPlan.productList[i].coverageConBeginDate){
                                var millisBeginDate = Date.parse(portalSelectedPlan.productList[i].coverageConBeginDate);
                            }else {
                                var millisBeginDate = Date.parse(portalSelectedPlan.productList[i].coverageBeginDate);
                            }
                            var millisEndDate = Date.parse(portalSelectedPlan.productList[i].coverageEndDate);
                            var coverageIsCurrent = false;
                            coverageIsCurrent = ((millisBeginDate < milliServerDate) && (milliServerDate < millisEndDate));
                            if (coverageIsCurrent && (portalSelectedPlan.productList[i].benefitPlanType === "Drug" || portalSelectedPlan.productList[i].benefitPlanType === "PrescriptionDrug" || portalSelectedPlan.productList[i].drugCoverage === "true")) {
                                showPrescription = true;
                            }
                        }
                        if (prescriptionServices && prescriptionServices.showPrescriptionService && showPrescription) {
                            $scope.showTool = prescriptionServices.showPrescriptionService;
                            $scope.urlObj = prescriptionServices;

                        }
                        if(prescriptionServices && !prescriptionServices.showPrescriptionService){
                            // Rx carve-outs do not have drug products or a value returned for pharmacyBenefitProviderIndicator.
                            // So we must check if the member is part of a client that has a Rx carve-out pharmacy vendor.
                            var rxCarveOutVendorPromise = healthToolsService.getRXCarveOutVendor();
                            rxCarveOutVendorPromise.then(function (response) {
                                if (response.qualifierInfo && response.qualifierInfo.rxCarveOutVendor && response.qualifierInfo.rxCarveOutVendor.trim().length > 0 && showPrescription) {
                                    $scope.showTool = true;
                                    $scope.urlObj={};

                                    if(prescriptionServicesJson && prescriptionServicesJson.arrPharmacyProviderUrls && prescriptionServicesJson.arrPharmacyProviderUrls[response.qualifierInfo.rxCarveOutVendor.trim().toUpperCase()] ){
                                        $scope.urlObj =  prescriptionServicesJson.arrPharmacyProviderUrls[response.qualifierInfo.rxCarveOutVendor.trim().toUpperCase()];
                                    }
                                    healthToolsService.getModel().selectedPlan.pharmacyBenefitProviderIndicator = response.qualifierInfo.rxCarveOutVendor.trim();
                                }

                            }, function () {
                                console.log("Error while fetching Qualifier services ");
                            });

                        }
                    }

                    $scope.ssoCall = function (ssoParams) {
                        var ssoParamsData = ssoParams? ssoParams: "";
                        if (ssoParamsData) {
                            if (ssoParamsData.disableSSO  && ssoParamsData.disableSSO.toUpperCase() == 'YES') {
                                $window.open($scope.toolLinkUrl, $scope.target);
                            } else {
                                ssoServiceHelper.ssoCall(ssoParamsData,"_blank",ssoParamsData.sitePromotionStr);
                            }
                        }
                    };

                    $scope.goToPrescriptionServices = function () {
                        if($scope.urlObj && $scope.urlObj.url){
                            var urlObj =  $scope.urlObj;
                            var targetUrl =  urlObj && urlObj.url?urlObj.url:"";
                            var isSSO = urlObj && urlObj.isSSO?urlObj.isSSO:"NO";
                            var urlTarget =  urlObj && urlObj.target?urlObj.target:"_blank";
                            var sitePromotionTag = urlObj && urlObj.sitePromotionTag?urlObj.sitePromotionTag:"";
                            var cmSP="";
                            if(sitePromotionTag){
                                cmSP = "cm_sp="+sitePromotionTag;
                            }
                            if (isSSO && isSSO.toUpperCase()!='YES' ) {
                                targetUrl = targetUrl +(cmSP?"&"+cmSP:"");
                                coremetrics.createManualLinkClickTag(targetUrl, null, null);
                                window.open(targetUrl,urlTarget);
                                return;
                            }
                            var model = healthToolsService.getModel();
                            var currentMember = model.currentMember;

                            var prescriptServiceSsoResponse = pharmacyServiceWrapper.doPharmacySsoCall(model.memberInfo, currentMember, model.selectedPlan, "Coverage");
                            var sitePromo = "";
                            var curPBMIndicator = model.selectedPlan.pharmacyBenefitProviderIndicator;

                            handleSsoResponse(prescriptServiceSsoResponse, urlTarget ? urlTarget : "_blank", cmSP);
                        }

                    }

                    var handleSsoResponse = function (prescriptServiceSsoResponse, theTargetType, sitePromo) {
                        if (prescriptServiceSsoResponse !== null) {
                            prescriptServiceSsoResponse.then(function (vendorSSOStuff) {
                                vendorSSOUtility.genericHandleSSOResponse(vendorSSOStuff, sitePromo, theTargetType);
                            }, function (error) {
                                vendorSSOUtility.genericHandleSSOFailure(error, theTargetType);
                            });
                        } else {
                            vendorSSOUtility.genericHandleSSOFailure("", theTargetType);
                        }
                    };

                    $scope.popToolModal = function () {
                        modal.open({
                            template: require('./modals/healthToolModal.html'),
                            controller: healthToolModal,
                            scope: $scope
                        });
                    };

                    $scope.doSSOCall = function (theTarget){
                        var openAsUrl = false;
                        if ($scope.ssoContent && $scope.ssoContent.sso) {
                            var ssoParamsData = $scope.ssoContent.sso[theTarget];

                            if (ssoParamsData.disableSSO  && ssoParamsData.disableSSO.toUpperCase() == 'YES') {
                                // If the SSO is disabled in config, open using URL instead of SSO.
                                openAsUrl = true;
                            } else {
                                ssoServiceHelper.ssoCall(ssoParamsData, "_blank", ssoParamsData.sitePromotionStr);
                            }
                        } else {
                            openAsUrl = true;
                        }
                        if (openAsUrl) {
                            var sitePromotionTag = $scope.ssoContent.url[theTarget].href.concat("?").concat($scope.ssoContent.url[theTarget].coremetrics.sitePromotionTag);
                            coremetrics.createManualLinkClickTag(sitePromotionTag, null, null);
                            window.open($scope.ssoContent.url[theTarget].href, '_blank');
                        }
                        modal.close({
                            template: require('./modals/healthToolModal.html'),
                            controller: healthToolModal,
                            scope: $scope
                        });
                    }
                    $scope.navigateTo = function () {
                        var toolType = $scope.toolType;
                        var openAsURL =false;
                        toolCoremetricsTagging(toolType);
                        if ($scope.openURL) {
                            $window.open($scope.toolLinkUrl, $scope.target);
                        }else if(toolType === 'COST-ESTIMATOR'){
                            if($scope.isCCE){
                                $window.open($scope.toolLinkUrl, $scope.target);
                            } if($scope.isCHC){
                                if($scope.chcSSOParams){
                                    $scope.ssoCall($scope.chcSSOParams);
                                }else{
                                    $window.open($scope.toolLinkUrl, $scope.target);
                                }
                            }
                        }else if(toolType === 'PAY-PREMIUM'){
                            $window.open($scope.toolLinkUrl, $scope.target);
                        } else if (toolType === 'SIMPLICITY-RX') {
                            var openUrl = $scope.toolLinkUrl + $scope.urlParamsSRX;
                            $window.open(openUrl, $scope.target);
                        }
                        else if (toolType === 'TELE-MEDICINE') {
                            $scope.popToolModal();
                        }
                        else if (toolType=== 'PRESCRIPTION-SERVICE') {
                            $scope.goToPrescriptionServices();
                        }

                    }
                }]
        };
    });

};
